import React from 'react';

interface TableFootProps {
    children: React.ReactNode;
    additionalClasses?: string;
}

const TableFoot: React.FC<TableFootProps> = (props) => {
    const { children, additionalClasses } = props;
    return <tfoot className={additionalClasses}>{children}</tfoot>;
};

export default TableFoot;
